import { components } from "react-select";

const CustomOption = (props) => {
  const { data, isSelected, selectProps } = props;

  const handleView = (e) => {
    e.stopPropagation();
    e.preventDefault();
    const url = data.value; // data.value is the signatureFilePath
    if (url && selectProps.onViewSignature) {
      selectProps.onViewSignature(url);
    }
  };

  return (
    <components.Option {...props}>
      <div className="certificate-option">
        <i
          className={`fa-solid fa-eye certificate-option-eye ${
            isSelected ? "selected" : ""
          }`}
          onClick={handleView}
        />

        <span>{data.label}</span>
      </div>
    </components.Option>
  );
};

export default CustomOption;
